import { useUser } from '~/lib/hooks'
import { Events } from '../lib/events'
import logger from '../lib/logger'

async function checkUserAuthStatus($api, $bus, store) {
  const { getUser } = useUser($api)
  const user = await getUser()

  if (!user) {
    return
  }

  $bus.$emit(Events.UserSignedIn, {
    user,
    enterprise: store.state.enterprise,
    track_analytics: false,
  })
}

export default function({ store, $api, $bus }) {
  logger.debug('check-auth-status.js: Checking if user is signed in')

  // Note: This is not awaited so that
  // the app does not hang while this is checked
  checkUserAuthStatus($api, $bus, store).catch(e => console.error(e))
}
